//const base_url = 'http://localhost:8080/fintasho/public/';
const base_url = 'https://fintback.neo.fo/';
export default base_url;